import { call } from 'redux-saga/effects';
import autocompleteSaga from './form.components/autocomplete/sagas.jsx';
import appLoaderSaga from './loader/sagas.jsx';
import fieldsSaga from './form.components/sagas.jsx';
import identicalGroupUpdateSaga from './form.components/family.cancer.history/sagas.jsx';

export default function* questionnaireSaga() {
    yield [
        call(appLoaderSaga),
        call(autocompleteSaga),
        call(fieldsSaga),
        call(identicalGroupUpdateSaga)
    ];
}
